export interface AnzsicCode {
  code: string;
  description: string;
  division: string;
  divisionName: string;
}

export const ANZSIC_CODES: AnzsicCode[] = [
  // Division A: Agriculture, Forestry and Fishing
  {
    code: "0111",
    description: "Nursery Production (Under Cover)",
    division: "A",
    divisionName: "Agriculture, Forestry and Fishing",
  },
  {
    code: "0112",
    description: "Nursery Production (Outdoors)",
    division: "A",
    divisionName: "Agriculture, Forestry and Fishing",
  },
  {
    code: "0113",
    description: "Turf Growing",
    division: "A",
    divisionName: "Agriculture, Forestry and Fishing",
  },
  {
    code: "0114",
    description: "Floriculture Production (Under Cover)",
    division: "A",
    divisionName: "Agriculture, Forestry and Fishing",
  },
  {
    code: "0115",
    description: "Floriculture Production (Outdoors)",
    division: "A",
    divisionName: "Agriculture, Forestry and Fishing",
  },
  {
    code: "0121",
    description: "Mushroom Growing",
    division: "A",
    divisionName: "Agriculture, Forestry and Fishing",
  },
  {
    code: "0122",
    description: "Vegetable Growing (Under Cover)",
    division: "A",
    divisionName: "Agriculture, Forestry and Fishing",
  },
  {
    code: "0123",
    description: "Vegetable Growing (Outdoors)",
    division: "A",
    divisionName: "Agriculture, Forestry and Fishing",
  },
  {
    code: "0131",
    description: "Grape Growing",
    division: "A",
    divisionName: "Agriculture, Forestry and Fishing",
  },
  {
    code: "0132",
    description: "Kiwifruit Growing",
    division: "A",
    divisionName: "Agriculture, Forestry and Fishing",
  },
  {
    code: "0133",
    description: "Berry Fruit Growing",
    division: "A",
    divisionName: "Agriculture, Forestry and Fishing",
  },
  {
    code: "0134",
    description: "Apple and Pear Growing",
    division: "A",
    divisionName: "Agriculture, Forestry and Fishing",
  },
  {
    code: "0135",
    description: "Stone Fruit Growing",
    division: "A",
    divisionName: "Agriculture, Forestry and Fishing",
  },
  {
    code: "0136",
    description: "Citrus Fruit Growing",
    division: "A",
    divisionName: "Agriculture, Forestry and Fishing",
  },
  {
    code: "0137",
    description: "Olive Growing",
    division: "A",
    divisionName: "Agriculture, Forestry and Fishing",
  },
  {
    code: "0139",
    description: "Other Fruit and Tree Nut Growing",
    division: "A",
    divisionName: "Agriculture, Forestry and Fishing",
  },
  {
    code: "0141",
    description: "Sheep Farming (Specialised)",
    division: "A",
    divisionName: "Agriculture, Forestry and Fishing",
  },
  {
    code: "0142",
    description: "Beef Cattle Farming (Specialised)",
    division: "A",
    divisionName: "Agriculture, Forestry and Fishing",
  },
  {
    code: "0143",
    description: "Beef Cattle Feedlots (Specialised)",
    division: "A",
    divisionName: "Agriculture, Forestry and Fishing",
  },
  {
    code: "0144",
    description: "Sheep-Beef Cattle Farming",
    division: "A",
    divisionName: "Agriculture, Forestry and Fishing",
  },
  {
    code: "0145",
    description: "Grain-Sheep or Grain-Beef Cattle Farming",
    division: "A",
    divisionName: "Agriculture, Forestry and Fishing",
  },
  {
    code: "0146",
    description: "Rice Growing",
    division: "A",
    divisionName: "Agriculture, Forestry and Fishing",
  },
  {
    code: "0149",
    description: "Other Grain Growing",
    division: "A",
    divisionName: "Agriculture, Forestry and Fishing",
  },
  {
    code: "0151",
    description: "Sugar Cane Growing",
    division: "A",
    divisionName: "Agriculture, Forestry and Fishing",
  },
  {
    code: "0152",
    description: "Cotton Growing",
    division: "A",
    divisionName: "Agriculture, Forestry and Fishing",
  },
  {
    code: "0159",
    description: "Other Crop Growing n.e.c.",
    division: "A",
    divisionName: "Agriculture, Forestry and Fishing",
  },
  {
    code: "0160",
    description: "Dairy Cattle Farming",
    division: "A",
    divisionName: "Agriculture, Forestry and Fishing",
  },
  {
    code: "0171",
    description: "Poultry Farming (Meat)",
    division: "A",
    divisionName: "Agriculture, Forestry and Fishing",
  },
  {
    code: "0172",
    description: "Poultry Farming (Eggs)",
    division: "A",
    divisionName: "Agriculture, Forestry and Fishing",
  },
  {
    code: "0180",
    description: "Deer Farming",
    division: "A",
    divisionName: "Agriculture, Forestry and Fishing",
  },
  {
    code: "0191",
    description: "Horse Farming",
    division: "A",
    divisionName: "Agriculture, Forestry and Fishing",
  },
  {
    code: "0192",
    description: "Pig Farming",
    division: "A",
    divisionName: "Agriculture, Forestry and Fishing",
  },
  {
    code: "0193",
    description: "Beekeeping",
    division: "A",
    divisionName: "Agriculture, Forestry and Fishing",
  },
  {
    code: "0199",
    description: "Other Livestock Farming n.e.c.",
    division: "A",
    divisionName: "Agriculture, Forestry and Fishing",
  },
  {
    code: "0201",
    description: "Offshore Longline and Rack Aquaculture",
    division: "A",
    divisionName: "Agriculture, Forestry and Fishing",
  },
  {
    code: "0202",
    description: "Offshore Caged Aquaculture",
    division: "A",
    divisionName: "Agriculture, Forestry and Fishing",
  },
  {
    code: "0203",
    description: "Onshore Aquaculture",
    division: "A",
    divisionName: "Agriculture, Forestry and Fishing",
  },
  {
    code: "0301",
    description: "Forestry",
    division: "A",
    divisionName: "Agriculture, Forestry and Fishing",
  },
  {
    code: "0302",
    description: "Logging",
    division: "A",
    divisionName: "Agriculture, Forestry and Fishing",
  },
  {
    code: "0411",
    description: "Rock Lobster and Crab Potting",
    division: "A",
    divisionName: "Agriculture, Forestry and Fishing",
  },
  {
    code: "0412",
    description: "Prawn Fishing",
    division: "A",
    divisionName: "Agriculture, Forestry and Fishing",
  },
  {
    code: "0413",
    description: "Line Fishing",
    division: "A",
    divisionName: "Agriculture, Forestry and Fishing",
  },
  {
    code: "0414",
    description: "Fish Trawling, Seining and Netting",
    division: "A",
    divisionName: "Agriculture, Forestry and Fishing",
  },
  {
    code: "0419",
    description: "Other Fishing",
    division: "A",
    divisionName: "Agriculture, Forestry and Fishing",
  },
  {
    code: "0420",
    description: "Hunting and Trapping",
    division: "A",
    divisionName: "Agriculture, Forestry and Fishing",
  },
  {
    code: "0510",
    description: "Forestry Support Services",
    division: "A",
    divisionName: "Agriculture, Forestry and Fishing",
  },
  {
    code: "0521",
    description: "Cotton Ginning",
    division: "A",
    divisionName: "Agriculture, Forestry and Fishing",
  },
  {
    code: "0522",
    description: "Shearing Services",
    division: "A",
    divisionName: "Agriculture, Forestry and Fishing",
  },
  {
    code: "0529",
    description: "Other Agriculture and Fishing Support Services",
    division: "A",
    divisionName: "Agriculture, Forestry and Fishing",
  },
  // Division B: Mining
  {
    code: "0600",
    description: "Coal Mining",
    division: "B",
    divisionName: "Mining",
  },
  {
    code: "0700",
    description: "Oil and Gas Extraction",
    division: "B",
    divisionName: "Mining",
  },
  {
    code: "0801",
    description: "Iron Ore Mining",
    division: "B",
    divisionName: "Mining",
  },
  {
    code: "0802",
    description: "Bauxite Mining",
    division: "B",
    divisionName: "Mining",
  },
  {
    code: "0803",
    description: "Copper Ore Mining",
    division: "B",
    divisionName: "Mining",
  },
  {
    code: "0804",
    description: "Gold Ore Mining",
    division: "B",
    divisionName: "Mining",
  },
  {
    code: "0805",
    description: "Mineral Sand Mining",
    division: "B",
    divisionName: "Mining",
  },
  {
    code: "0806",
    description: "Nickel Ore Mining",
    division: "B",
    divisionName: "Mining",
  },
  {
    code: "0807",
    description: "Silver-Lead-Zinc Ore Mining",
    division: "B",
    divisionName: "Mining",
  },
  {
    code: "0809",
    description: "Other Metal Ore Mining",
    division: "B",
    divisionName: "Mining",
  },
  {
    code: "0911",
    description: "Gravel and Sand Quarrying",
    division: "B",
    divisionName: "Mining",
  },
  {
    code: "0919",
    description: "Other Construction Material Mining",
    division: "B",
    divisionName: "Mining",
  },
  {
    code: "0990",
    description: "Other Non-Metallic Mineral Mining and Quarrying",
    division: "B",
    divisionName: "Mining",
  },
  {
    code: "1011",
    description: "Petroleum Exploration",
    division: "B",
    divisionName: "Mining",
  },
  {
    code: "1012",
    description: "Mineral Exploration",
    division: "B",
    divisionName: "Mining",
  },
  {
    code: "1090",
    description: "Other Mining Support Services",
    division: "B",
    divisionName: "Mining",
  },
  // Division C: Manufacturing
  {
    code: "1111",
    description: "Meat Processing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1112",
    description: "Poultry Processing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1113",
    description: "Cured Meat and Smallgoods Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1120",
    description: "Seafood Processing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1131",
    description: "Milk and Cream Processing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1132",
    description: "Ice Cream Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1133",
    description: "Cheese and Other Dairy Product Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1140",
    description: "Fruit and Vegetable Processing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1150",
    description: "Oil and Fat Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1161",
    description: "Grain Mill Product Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1162",
    description: "Cereal, Pasta and Baking Mix Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1171",
    description: "Bread Manufacturing (Factory based)",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1172",
    description: "Cake and Pastry Manufacturing (Factory based)",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1173",
    description: "Biscuit Manufacturing (Factory based)",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1174",
    description: "Bakery Product Manufacturing (Non-factory based)",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1181",
    description: "Sugar Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1182",
    description: "Confectionery Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1191",
    description: "Potato, Corn and Other Crisp Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1192",
    description: "Prepared Animal and Bird Feed Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1199",
    description: "Other Food Product Manufacturing n.e.c.",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1211",
    description: "Soft Drink, Cordial and Syrup Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1212",
    description: "Beer Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1213",
    description: "Spirit Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1214",
    description: "Wine and Other Alcoholic Beverage Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1220",
    description: "Cigarette and Tobacco Product Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1311",
    description: "Wool Scouring",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1312",
    description: "Natural Textile Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1313",
    description: "Synthetic Textile Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1320",
    description:
      "Leather Tanning, Fur Dressing and Leather Product Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1331",
    description: "Textile Floor Covering Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1332",
    description: "Rope, Cordage and Twine Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1333",
    description: "Cut and Sewn Textile Product Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1334",
    description: "Textile Finishing and Other Textile Product Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1340",
    description: "Knitted Product Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1351",
    description: "Clothing Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1352",
    description: "Footwear Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1411",
    description: "Log Sawmilling",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1412",
    description: "Wood Chipping",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1413",
    description: "Timber Resawing and Dressing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1491",
    description: "Prefabricated Wooden Building Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1492",
    description: "Wooden Structural Fitting and Component Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1493",
    description: "Veneer and Plywood Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1494",
    description: "Reconstituted Wood Product Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1499",
    description: "Other Wood Product Manufacturing n.e.c.",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1510",
    description: "Pulp, Paper and Paperboard Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1521",
    description: "Corrugated Paperboard and Paperboard Container Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1522",
    description: "Paper Bag Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1523",
    description: "Paper Stationery Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1524",
    description: "Sanitary Paper Product Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1529",
    description: "Other Converted Paper Product Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1611",
    description: "Printing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1612",
    description: "Printing Support Services",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1620",
    description: "Reproduction of Recorded Media",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1701",
    description: "Petroleum Refining and Petroleum Fuel Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1709",
    description: "Other Petroleum and Coal Product Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1811",
    description: "Industrial Gas Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1812",
    description: "Basic Organic Chemical Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1813",
    description: "Basic Inorganic Chemical Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1821",
    description: "Synthetic Resin and Synthetic Rubber Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1829",
    description: "Other Basic Polymer Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1831",
    description: "Fertiliser Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1832",
    description: "Pesticide Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1841",
    description: "Human Pharmaceutical and Medicinal Product Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1842",
    description:
      "Veterinary Pharmaceutical and Medicinal Product Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1851",
    description: "Cleaning Compound Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1852",
    description: "Cosmetic and Toiletry Preparation Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1891",
    description: "Photographic Chemical Product Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1892",
    description: "Explosive Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1899",
    description: "Other Basic Chemical Product Manufacturing n.e.c.",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1911",
    description: "Polymer Film and Sheet Packaging Material Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1912",
    description: "Rigid and Semi-Rigid Polymer Product Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1913",
    description: "Polymer Foam Product Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1914",
    description: "Tyre Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1915",
    description: "Adhesive Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1916",
    description: "Paint and Coatings Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1919",
    description: "Other Polymer Product Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "1920",
    description: "Natural Rubber Product Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2010",
    description: "Glass and Glass Product Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2021",
    description: "Clay Brick Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2029",
    description: "Other Ceramic Product Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2031",
    description: "Cement and Lime Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2032",
    description: "Plaster Product Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2033",
    description: "Ready-Mixed Concrete Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2034",
    description: "Concrete Product Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2090",
    description: "Other Non-Metallic Mineral Product Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2110",
    description: "Iron Smelting and Steel Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2121",
    description: "Iron and Steel Casting",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2122",
    description: "Steel Pipe and Tube Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2131",
    description: "Alumina Production",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2132",
    description: "Aluminium Smelting",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2133",
    description: "Copper, Silver, Lead and Zinc Smelting and Refining",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2139",
    description: "Other Basic Non-Ferrous Metal Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2141",
    description: "Non-Ferrous Metal Casting",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2142",
    description: "Aluminium Rolling, Drawing, Extruding",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2149",
    description: "Other Basic Non-Ferrous Metal Product Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2210",
    description: "Iron and Steel Forging",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2221",
    description: "Structural Steel Fabricating",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2222",
    description: "Prefabricated Metal Building Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2223",
    description: "Architectural Aluminium Product Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2224",
    description: "Metal Roof and Guttering Manufacturing (except Aluminium)",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2229",
    description: "Other Structural Metal Product Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2231",
    description:
      "Boiler, Tank and Other Heavy Gauge Metal Container Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2239",
    description: "Other Metal Container Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2240",
    description: "Sheet Metal Product Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2291",
    description: "Spring and Wire Product Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2292",
    description: "Nut, Bolt, Screw and Rivet Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2293",
    description: "Metal Coating and Finishing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2299",
    description: "Other Fabricated Metal Product Manufacturing n.e.c.",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2311",
    description: "Motor Vehicle Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2312",
    description: "Motor Vehicle Body and Trailer Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2313",
    description: "Automotive Electrical Component Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2319",
    description: "Other Motor Vehicle Parts Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2391",
    description: "Shipbuilding and Repair Services",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2392",
    description: "Boatbuilding and Repair Services",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2393",
    description: "Railway Rolling Stock Manufacturing and Repair Services",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2394",
    description: "Aircraft Manufacturing and Repair Services",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2399",
    description: "Other Transport Equipment Manufacturing n.e.c.",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2411",
    description: "Photographic, Optical and Ophthalmic Equipment Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2412",
    description: "Medical and Surgical Equipment Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2419",
    description: "Other Professional and Scientific Equipment Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2421",
    description: "Computer and Electronic Office Equipment Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2422",
    description: "Communication Equipment Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2429",
    description: "Other Electronic Equipment Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2431",
    description: "Electric Cable and Wire Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2432",
    description: "Electric Lighting Equipment Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2439",
    description: "Other Electrical Equipment Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2441",
    description: "Whiteware Appliance Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2449",
    description: "Other Domestic Appliance Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2451",
    description: "Pump and Compressor Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2452",
    description:
      "Fixed Space Heating, Cooling and Ventilation Equipment Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2461",
    description: "Agricultural Machinery and Equipment Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2462",
    description: "Mining and Construction Machinery Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2463",
    description: "Machine Tool and Parts Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2469",
    description: "Other Specialised Machinery and Equipment Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2491",
    description: "Lifting and Material Handling Equipment Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2499",
    description: "Other Machinery and Equipment Manufacturing n.e.c.",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2511",
    description: "Wooden Furniture and Upholstered Seat Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2512",
    description: "Metal Furniture Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2513",
    description: "Mattress Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2519",
    description: "Other Furniture Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2591",
    description: "Jewellery and Silverware Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2592",
    description: "Toy, Sporting and Recreational Product Manufacturing",
    division: "C",
    divisionName: "Manufacturing",
  },
  {
    code: "2599",
    description: "Other Manufacturing n.e.c.",
    division: "C",
    divisionName: "Manufacturing",
  },
  // Division D: Electricity, Gas, Water and Waste Services
  {
    code: "2611",
    description: "Fossil Fuel Electricity Generation",
    division: "D",
    divisionName: "Electricity, Gas, Water and Waste Services",
  },
  {
    code: "2612",
    description: "Hydro-Electricity Generation",
    division: "D",
    divisionName: "Electricity, Gas, Water and Waste Services",
  },
  {
    code: "2619",
    description: "Other Electricity Generation",
    division: "D",
    divisionName: "Electricity, Gas, Water and Waste Services",
  },
  {
    code: "2620",
    description: "Electricity Transmission",
    division: "D",
    divisionName: "Electricity, Gas, Water and Waste Services",
  },
  {
    code: "2630",
    description: "Electricity Distribution",
    division: "D",
    divisionName: "Electricity, Gas, Water and Waste Services",
  },
  {
    code: "2640",
    description: "On Selling Electricity and Electricity Market Operation",
    division: "D",
    divisionName: "Electricity, Gas, Water and Waste Services",
  },
  {
    code: "2700",
    description: "Gas Supply",
    division: "D",
    divisionName: "Electricity, Gas, Water and Waste Services",
  },
  {
    code: "2811",
    description: "Water Supply",
    division: "D",
    divisionName: "Electricity, Gas, Water and Waste Services",
  },
  {
    code: "2812",
    description: "Sewerage and Drainage Services",
    division: "D",
    divisionName: "Electricity, Gas, Water and Waste Services",
  },
  {
    code: "2911",
    description: "Solid Waste Collection Services",
    division: "D",
    divisionName: "Electricity, Gas, Water and Waste Services",
  },
  {
    code: "2919",
    description: "Other Waste Collection Services",
    division: "D",
    divisionName: "Electricity, Gas, Water and Waste Services",
  },
  {
    code: "2921",
    description: "Waste Treatment and Disposal Services",
    division: "D",
    divisionName: "Electricity, Gas, Water and Waste Services",
  },
  {
    code: "2922",
    description: "Waste Remediation and Materials Recovery Services",
    division: "D",
    divisionName: "Electricity, Gas, Water and Waste Services",
  },
  // Division E: Construction
  {
    code: "3011",
    description: "Residential Building Construction",
    division: "E",
    divisionName: "Construction",
  },
  {
    code: "3019",
    description: "Non-Residential Building Construction",
    division: "E",
    divisionName: "Construction",
  },
  {
    code: "3020",
    description: "Heavy and Civil Engineering Construction",
    division: "E",
    divisionName: "Construction",
  },
  {
    code: "3101",
    description: "Land Development and Subdivision",
    division: "E",
    divisionName: "Construction",
  },
  {
    code: "3109",
    description: "Site Preparation Services n.e.c.",
    division: "E",
    divisionName: "Construction",
  },
  {
    code: "3211",
    description: "Concreting Services",
    division: "E",
    divisionName: "Construction",
  },
  {
    code: "3212",
    description: "Bricklaying Services",
    division: "E",
    divisionName: "Construction",
  },
  {
    code: "3221",
    description: "Roofing Services",
    division: "E",
    divisionName: "Construction",
  },
  {
    code: "3222",
    description: "Structural Steel Erection Services",
    division: "E",
    divisionName: "Construction",
  },
  {
    code: "3223",
    description: "Plumbing Services",
    division: "E",
    divisionName: "Construction",
  },
  {
    code: "3224",
    description: "Electrical Services",
    division: "E",
    divisionName: "Construction",
  },
  {
    code: "3231",
    description: "Air Conditioning and Heating Services",
    division: "E",
    divisionName: "Construction",
  },
  {
    code: "3232",
    description: "Fire and Security Alarm Installation Services",
    division: "E",
    divisionName: "Construction",
  },
  {
    code: "3233",
    description: "Antenna Installation Services",
    division: "E",
    divisionName: "Construction",
  },
  {
    code: "3234",
    description: "Insulation Installation Services",
    division: "E",
    divisionName: "Construction",
  },
  {
    code: "3239",
    description: "Other Building Installation Services",
    division: "E",
    divisionName: "Construction",
  },
  {
    code: "3241",
    description: "Plastering and Ceiling Services",
    division: "E",
    divisionName: "Construction",
  },
  {
    code: "3242",
    description: "Carpentry Services",
    division: "E",
    divisionName: "Construction",
  },
  {
    code: "3243",
    description: "Tiling and Carpeting Services",
    division: "E",
    divisionName: "Construction",
  },
  {
    code: "3244",
    description: "Painting and Decorating Services",
    division: "E",
    divisionName: "Construction",
  },
  {
    code: "3245",
    description: "Glazing Services",
    division: "E",
    divisionName: "Construction",
  },
  {
    code: "3291",
    description: "Landscape Construction Services",
    division: "E",
    divisionName: "Construction",
  },
  {
    code: "3292",
    description: "Hire of Construction Machinery with Operator",
    division: "E",
    divisionName: "Construction",
  },
  {
    code: "3299",
    description: "Other Construction Services n.e.c.",
    division: "E",
    divisionName: "Construction",
  },
  // Division F: Wholesale Trade
  {
    code: "3311",
    description: "Wool Wholesaling",
    division: "F",
    divisionName: "Wholesale Trade",
  },
  {
    code: "3312",
    description: "Cereal Grain Wholesaling",
    division: "F",
    divisionName: "Wholesale Trade",
  },
  {
    code: "3319",
    description: "Other Agricultural Product Wholesaling",
    division: "F",
    divisionName: "Wholesale Trade",
  },
  {
    code: "3321",
    description: "Petroleum Product Wholesaling",
    division: "F",
    divisionName: "Wholesale Trade",
  },
  {
    code: "3322",
    description: "Metal and Mineral Wholesaling",
    division: "F",
    divisionName: "Wholesale Trade",
  },
  {
    code: "3323",
    description: "Industrial and Agricultural Chemical Product Wholesaling",
    division: "F",
    divisionName: "Wholesale Trade",
  },
  {
    code: "3331",
    description: "Timber Wholesaling",
    division: "F",
    divisionName: "Wholesale Trade",
  },
  {
    code: "3332",
    description: "Plumbing Goods Wholesaling",
    division: "F",
    divisionName: "Wholesale Trade",
  },
  {
    code: "3339",
    description: "Other Hardware Goods Wholesaling",
    division: "F",
    divisionName: "Wholesale Trade",
  },
  {
    code: "3411",
    description: "Agricultural and Construction Machinery Wholesaling",
    division: "F",
    divisionName: "Wholesale Trade",
  },
  {
    code: "3419",
    description:
      "Other Specialised Industrial Machinery and Equipment Wholesaling",
    division: "F",
    divisionName: "Wholesale Trade",
  },
  {
    code: "3491",
    description: "Professional and Scientific Goods Wholesaling",
    division: "F",
    divisionName: "Wholesale Trade",
  },
  {
    code: "3492",
    description: "Computer and Computer Peripheral Wholesaling",
    division: "F",
    divisionName: "Wholesale Trade",
  },
  {
    code: "3493",
    description: "Telecommunication Goods Wholesaling",
    division: "F",
    divisionName: "Wholesale Trade",
  },
  {
    code: "3494",
    description: "Other Electrical and Electronic Goods Wholesaling",
    division: "F",
    divisionName: "Wholesale Trade",
  },
  {
    code: "3499",
    description: "Other Machinery and Equipment Wholesaling n.e.c.",
    division: "F",
    divisionName: "Wholesale Trade",
  },
  {
    code: "3501",
    description: "Car Wholesaling",
    division: "F",
    divisionName: "Wholesale Trade",
  },
  {
    code: "3502",
    description: "Commercial Vehicle Wholesaling",
    division: "F",
    divisionName: "Wholesale Trade",
  },
  {
    code: "3503",
    description: "Trailer and Other Motor Vehicle Wholesaling",
    division: "F",
    divisionName: "Wholesale Trade",
  },
  {
    code: "3504",
    description: "Motor Vehicle New Parts Wholesaling",
    division: "F",
    divisionName: "Wholesale Trade",
  },
  {
    code: "3505",
    description: "Motor Vehicle Dismantling and Used Parts Wholesaling",
    division: "F",
    divisionName: "Wholesale Trade",
  },
  {
    code: "3601",
    description: "General Line Grocery Wholesaling",
    division: "F",
    divisionName: "Wholesale Trade",
  },
  {
    code: "3602",
    description: "Meat, Poultry and Smallgoods Wholesaling",
    division: "F",
    divisionName: "Wholesale Trade",
  },
  {
    code: "3603",
    description: "Dairy Produce Wholesaling",
    division: "F",
    divisionName: "Wholesale Trade",
  },
  {
    code: "3604",
    description: "Fish and Seafood Wholesaling",
    division: "F",
    divisionName: "Wholesale Trade",
  },
  {
    code: "3605",
    description: "Fruit and Vegetable Wholesaling",
    division: "F",
    divisionName: "Wholesale Trade",
  },
  {
    code: "3606",
    description: "Liquor and Tobacco Product Wholesaling",
    division: "F",
    divisionName: "Wholesale Trade",
  },
  {
    code: "3609",
    description: "Other Grocery Wholesaling",
    division: "F",
    divisionName: "Wholesale Trade",
  },
  {
    code: "3711",
    description: "Textile Product Wholesaling",
    division: "F",
    divisionName: "Wholesale Trade",
  },
  {
    code: "3712",
    description: "Clothing and Footwear Wholesaling",
    division: "F",
    divisionName: "Wholesale Trade",
  },
  {
    code: "3720",
    description: "Pharmaceutical and Toiletry Goods Wholesaling",
    division: "F",
    divisionName: "Wholesale Trade",
  },
  {
    code: "3731",
    description: "Furniture and Floor Covering Wholesaling",
    division: "F",
    divisionName: "Wholesale Trade",
  },
  {
    code: "3732",
    description: "Jewellery and Watch Wholesaling",
    division: "F",
    divisionName: "Wholesale Trade",
  },
  {
    code: "3733",
    description: "Kitchen and Diningware Wholesaling",
    division: "F",
    divisionName: "Wholesale Trade",
  },
  {
    code: "3734",
    description: "Toy and Sporting Goods Wholesaling",
    division: "F",
    divisionName: "Wholesale Trade",
  },
  {
    code: "3735",
    description: "Book and Magazine Wholesaling",
    division: "F",
    divisionName: "Wholesale Trade",
  },
  {
    code: "3736",
    description: "Paper Product Wholesaling",
    division: "F",
    divisionName: "Wholesale Trade",
  },
  {
    code: "3739",
    description: "Other Goods Wholesaling n.e.c.",
    division: "F",
    divisionName: "Wholesale Trade",
  },
  {
    code: "3800",
    description: "Commission-Based Wholesaling",
    division: "F",
    divisionName: "Wholesale Trade",
  },
  // Division G: Retail Trade
  {
    code: "3911",
    description: "Car Retailing",
    division: "G",
    divisionName: "Retail Trade",
  },
  {
    code: "3912",
    description: "Motor Cycle Retailing",
    division: "G",
    divisionName: "Retail Trade",
  },
  {
    code: "3913",
    description: "Trailer and Other Motor Vehicle Retailing",
    division: "G",
    divisionName: "Retail Trade",
  },
  {
    code: "3921",
    description: "Motor Vehicle Parts Retailing",
    division: "G",
    divisionName: "Retail Trade",
  },
  {
    code: "3922",
    description: "Tyre Retailing",
    division: "G",
    divisionName: "Retail Trade",
  },
  {
    code: "4000",
    description: "Fuel Retailing",
    division: "G",
    divisionName: "Retail Trade",
  },
  {
    code: "4110",
    description: "Supermarket and Grocery Stores",
    division: "G",
    divisionName: "Retail Trade",
  },
  {
    code: "4121",
    description: "Fresh Meat, Fish and Poultry Retailing",
    division: "G",
    divisionName: "Retail Trade",
  },
  {
    code: "4122",
    description: "Fruit and Vegetable Retailing",
    division: "G",
    divisionName: "Retail Trade",
  },
  {
    code: "4123",
    description: "Liquor Retailing",
    division: "G",
    divisionName: "Retail Trade",
  },
  {
    code: "4129",
    description: "Other Specialised Food Retailing",
    division: "G",
    divisionName: "Retail Trade",
  },
  {
    code: "4211",
    description: "Furniture Retailing",
    division: "G",
    divisionName: "Retail Trade",
  },
  {
    code: "4212",
    description: "Floor Covering Retailing",
    division: "G",
    divisionName: "Retail Trade",
  },
  {
    code: "4213",
    description: "Houseware Retailing",
    division: "G",
    divisionName: "Retail Trade",
  },
  {
    code: "4214",
    description: "Manchester and Other Textile Goods Retailing",
    division: "G",
    divisionName: "Retail Trade",
  },
  {
    code: "4221",
    description: "Electrical, Electronic and Gas Appliance Retailing",
    division: "G",
    divisionName: "Retail Trade",
  },
  {
    code: "4222",
    description: "Computer and Computer Peripheral Retailing",
    division: "G",
    divisionName: "Retail Trade",
  },
  {
    code: "4229",
    description: "Other Electrical and Electronic Goods Retailing",
    division: "G",
    divisionName: "Retail Trade",
  },
  {
    code: "4231",
    description: "Hardware and Building Supplies Retailing",
    division: "G",
    divisionName: "Retail Trade",
  },
  {
    code: "4232",
    description: "Garden Supplies Retailing",
    division: "G",
    divisionName: "Retail Trade",
  },
  {
    code: "4241",
    description: "Sport and Camping Equipment Retailing",
    division: "G",
    divisionName: "Retail Trade",
  },
  {
    code: "4242",
    description: "Entertainment Media Retailing",
    division: "G",
    divisionName: "Retail Trade",
  },
  {
    code: "4243",
    description: "Toy and Game Retailing",
    division: "G",
    divisionName: "Retail Trade",
  },
  {
    code: "4244",
    description: "Newspaper and Book Retailing",
    division: "G",
    divisionName: "Retail Trade",
  },
  {
    code: "4245",
    description: "Marine Equipment Retailing",
    division: "G",
    divisionName: "Retail Trade",
  },
  {
    code: "4251",
    description: "Clothing Retailing",
    division: "G",
    divisionName: "Retail Trade",
  },
  {
    code: "4252",
    description: "Footwear Retailing",
    division: "G",
    divisionName: "Retail Trade",
  },
  {
    code: "4253",
    description: "Watch and Jewellery Retailing",
    division: "G",
    divisionName: "Retail Trade",
  },
  {
    code: "4259",
    description: "Other Personal Accessory Retailing",
    division: "G",
    divisionName: "Retail Trade",
  },
  {
    code: "4260",
    description: "Department Stores",
    division: "G",
    divisionName: "Retail Trade",
  },
  {
    code: "4271",
    description: "Pharmaceutical, Cosmetic and Toiletry Goods Retailing",
    division: "G",
    divisionName: "Retail Trade",
  },
  {
    code: "4272",
    description: "Stationery Goods Retailing",
    division: "G",
    divisionName: "Retail Trade",
  },
  {
    code: "4273",
    description: "Antique and Used Goods Retailing",
    division: "G",
    divisionName: "Retail Trade",
  },
  {
    code: "4274",
    description: "Flower Retailing",
    division: "G",
    divisionName: "Retail Trade",
  },
  {
    code: "4279",
    description: "Other Store-Based Retailing n.e.c.",
    division: "G",
    divisionName: "Retail Trade",
  },
  {
    code: "4310",
    description: "Non-Store Retailing",
    division: "G",
    divisionName: "Retail Trade",
  },
  {
    code: "4320",
    description: "Retail Commission-Based Buying and/or Selling",
    division: "G",
    divisionName: "Retail Trade",
  },
  // Division H: Accommodation and Food Services
  {
    code: "4400",
    description: "Accommodation",
    division: "H",
    divisionName: "Accommodation and Food Services",
  },
  {
    code: "4511",
    description: "Cafes and Restaurants",
    division: "H",
    divisionName: "Accommodation and Food Services",
  },
  {
    code: "4512",
    description: "Takeaway Food Services",
    division: "H",
    divisionName: "Accommodation and Food Services",
  },
  {
    code: "4513",
    description: "Catering Services",
    division: "H",
    divisionName: "Accommodation and Food Services",
  },
  {
    code: "4520",
    description: "Pubs, Taverns and Bars",
    division: "H",
    divisionName: "Accommodation and Food Services",
  },
  {
    code: "4530",
    description: "Clubs (Hospitality)",
    division: "H",
    divisionName: "Accommodation and Food Services",
  },
  // Division I: Transport, Postal and Warehousing
  {
    code: "4610",
    description: "Road Freight Transport",
    division: "I",
    divisionName: "Transport, Postal and Warehousing",
  },
  {
    code: "4621",
    description: "Interurban and Rural Bus Transport",
    division: "I",
    divisionName: "Transport, Postal and Warehousing",
  },
  {
    code: "4622",
    description: "Urban Bus Transport (Including Tramway)",
    division: "I",
    divisionName: "Transport, Postal and Warehousing",
  },
  {
    code: "4623",
    description: "Taxi and Other Road Transport",
    division: "I",
    divisionName: "Transport, Postal and Warehousing",
  },
  {
    code: "4710",
    description: "Rail Freight Transport",
    division: "I",
    divisionName: "Transport, Postal and Warehousing",
  },
  {
    code: "4720",
    description: "Rail Passenger Transport",
    division: "I",
    divisionName: "Transport, Postal and Warehousing",
  },
  {
    code: "4810",
    description: "Water Freight Transport",
    division: "I",
    divisionName: "Transport, Postal and Warehousing",
  },
  {
    code: "4820",
    description: "Water Passenger Transport",
    division: "I",
    divisionName: "Transport, Postal and Warehousing",
  },
  {
    code: "4900",
    description: "Air and Space Transport",
    division: "I",
    divisionName: "Transport, Postal and Warehousing",
  },
  {
    code: "5010",
    description: "Scenic and Sightseeing Transport",
    division: "I",
    divisionName: "Transport, Postal and Warehousing",
  },
  {
    code: "5021",
    description: "Pipeline Transport",
    division: "I",
    divisionName: "Transport, Postal and Warehousing",
  },
  {
    code: "5029",
    description: "Other Transport n.e.c.",
    division: "I",
    divisionName: "Transport, Postal and Warehousing",
  },
  {
    code: "5101",
    description: "Postal Services",
    division: "I",
    divisionName: "Transport, Postal and Warehousing",
  },
  {
    code: "5102",
    description: "Courier Pick-up and Delivery Services",
    division: "I",
    divisionName: "Transport, Postal and Warehousing",
  },
  {
    code: "5211",
    description: "Stevedoring Services",
    division: "I",
    divisionName: "Transport, Postal and Warehousing",
  },
  {
    code: "5212",
    description: "Port and Water Transport Terminal Operations",
    division: "I",
    divisionName: "Transport, Postal and Warehousing",
  },
  {
    code: "5219",
    description: "Other Water Transport Support Services",
    division: "I",
    divisionName: "Transport, Postal and Warehousing",
  },
  {
    code: "5220",
    description: "Airport Operations and Other Air Transport Support Services",
    division: "I",
    divisionName: "Transport, Postal and Warehousing",
  },
  {
    code: "5291",
    description: "Customs Agency Services",
    division: "I",
    divisionName: "Transport, Postal and Warehousing",
  },
  {
    code: "5292",
    description: "Freight Forwarding Services",
    division: "I",
    divisionName: "Transport, Postal and Warehousing",
  },
  {
    code: "5299",
    description: "Other Transport Support Services n.e.c.",
    division: "I",
    divisionName: "Transport, Postal and Warehousing",
  },
  {
    code: "5301",
    description: "Grain Storage Services",
    division: "I",
    divisionName: "Transport, Postal and Warehousing",
  },
  {
    code: "5309",
    description: "Other Warehousing and Storage Services",
    division: "I",
    divisionName: "Transport, Postal and Warehousing",
  },
  // Division J: Information Media and Telecommunications
  {
    code: "5411",
    description: "Newspaper Publishing",
    division: "J",
    divisionName: "Information Media and Telecommunications",
  },
  {
    code: "5412",
    description: "Magazine and Other Periodical Publishing",
    division: "J",
    divisionName: "Information Media and Telecommunications",
  },
  {
    code: "5413",
    description: "Book Publishing",
    division: "J",
    divisionName: "Information Media and Telecommunications",
  },
  {
    code: "5414",
    description: "Directory and Mailing List Publishing",
    division: "J",
    divisionName: "Information Media and Telecommunications",
  },
  {
    code: "5419",
    description: "Other Publishing (except Software, Music and Internet)",
    division: "J",
    divisionName: "Information Media and Telecommunications",
  },
  {
    code: "5420",
    description: "Software Publishing",
    division: "J",
    divisionName: "Information Media and Telecommunications",
  },
  {
    code: "5511",
    description: "Motion Picture and Video Production",
    division: "J",
    divisionName: "Information Media and Telecommunications",
  },
  {
    code: "5512",
    description: "Motion Picture and Video Distribution",
    division: "J",
    divisionName: "Information Media and Telecommunications",
  },
  {
    code: "5513",
    description: "Motion Picture Exhibition",
    division: "J",
    divisionName: "Information Media and Telecommunications",
  },
  {
    code: "5514",
    description:
      "Post-production Services and Other Motion Picture and Video Activities",
    division: "J",
    divisionName: "Information Media and Telecommunications",
  },
  {
    code: "5521",
    description: "Music Publishing",
    division: "J",
    divisionName: "Information Media and Telecommunications",
  },
  {
    code: "5522",
    description: "Music and Other Sound Recording Activities",
    division: "J",
    divisionName: "Information Media and Telecommunications",
  },
  {
    code: "5610",
    description: "Radio Broadcasting",
    division: "J",
    divisionName: "Information Media and Telecommunications",
  },
  {
    code: "5621",
    description: "Free-to-Air Television Broadcasting",
    division: "J",
    divisionName: "Information Media and Telecommunications",
  },
  {
    code: "5622",
    description: "Cable and Other Subscription Broadcasting",
    division: "J",
    divisionName: "Information Media and Telecommunications",
  },
  {
    code: "5700",
    description: "Internet Publishing and Broadcasting",
    division: "J",
    divisionName: "Information Media and Telecommunications",
  },
  {
    code: "5801",
    description: "Wired Telecommunications Network Operation",
    division: "J",
    divisionName: "Information Media and Telecommunications",
  },
  {
    code: "5802",
    description: "Other Telecommunications Network Operation",
    division: "J",
    divisionName: "Information Media and Telecommunications",
  },
  {
    code: "5809",
    description: "Other Telecommunications Services",
    division: "J",
    divisionName: "Information Media and Telecommunications",
  },
  {
    code: "5910",
    description: "Internet Service Providers and Web Search Portals",
    division: "J",
    divisionName: "Information Media and Telecommunications",
  },
  {
    code: "5921",
    description: "Data Processing and Web Hosting Services",
    division: "J",
    divisionName: "Information Media and Telecommunications",
  },
  {
    code: "5922",
    description: "Electronic Information Storage Services",
    division: "J",
    divisionName: "Information Media and Telecommunications",
  },
  {
    code: "6010",
    description: "Libraries and Archives",
    division: "J",
    divisionName: "Information Media and Telecommunications",
  },
  {
    code: "6020",
    description: "Other Information Services",
    division: "J",
    divisionName: "Information Media and Telecommunications",
  },
  // Division K: Financial and Insurance Services
  {
    code: "6210",
    description: "Central Banking",
    division: "K",
    divisionName: "Financial and Insurance Services",
  },
  {
    code: "6221",
    description: "Banking",
    division: "K",
    divisionName: "Financial and Insurance Services",
  },
  {
    code: "6222",
    description: "Building Society Operation",
    division: "K",
    divisionName: "Financial and Insurance Services",
  },
  {
    code: "6223",
    description: "Credit Union Operation",
    division: "K",
    divisionName: "Financial and Insurance Services",
  },
  {
    code: "6229",
    description: "Other Depository Financial Intermediation",
    division: "K",
    divisionName: "Financial and Insurance Services",
  },
  {
    code: "6230",
    description: "Non-Depository Financing",
    division: "K",
    divisionName: "Financial and Insurance Services",
  },
  {
    code: "6240",
    description: "Financial Asset Investing",
    division: "K",
    divisionName: "Financial and Insurance Services",
  },
  {
    code: "6310",
    description: "Life Insurance",
    division: "K",
    divisionName: "Financial and Insurance Services",
  },
  {
    code: "6321",
    description: "Health Insurance",
    division: "K",
    divisionName: "Financial and Insurance Services",
  },
  {
    code: "6322",
    description: "General Insurance",
    division: "K",
    divisionName: "Financial and Insurance Services",
  },
  {
    code: "6330",
    description: "Superannuation Funds",
    division: "K",
    divisionName: "Financial and Insurance Services",
  },
  {
    code: "6411",
    description: "Financial Asset Broking Services",
    division: "K",
    divisionName: "Financial and Insurance Services",
  },
  {
    code: "6419",
    description: "Other Auxiliary Finance and Investment Services",
    division: "K",
    divisionName: "Financial and Insurance Services",
  },
  {
    code: "6420",
    description: "Auxiliary Insurance Services",
    division: "K",
    divisionName: "Financial and Insurance Services",
  },
  // Division L: Rental, Hiring and Real Estate Services
  {
    code: "6611",
    description: "Passenger Car Rental and Hiring",
    division: "L",
    divisionName: "Rental, Hiring and Real Estate Services",
  },
  {
    code: "6619",
    description:
      "Other Motor Vehicle and Transport Equipment Rental and Hiring",
    division: "L",
    divisionName: "Rental, Hiring and Real Estate Services",
  },
  {
    code: "6620",
    description: "Farm Animal and Bloodstock Leasing",
    division: "L",
    divisionName: "Rental, Hiring and Real Estate Services",
  },
  {
    code: "6631",
    description: "Heavy Machinery and Scaffolding Rental and Hiring",
    division: "L",
    divisionName: "Rental, Hiring and Real Estate Services",
  },
  {
    code: "6632",
    description: "Video and Other Electronic Media Rental and Hiring",
    division: "L",
    divisionName: "Rental, Hiring and Real Estate Services",
  },
  {
    code: "6639",
    description: "Other Goods and Equipment Rental and Hiring n.e.c.",
    division: "L",
    divisionName: "Rental, Hiring and Real Estate Services",
  },
  {
    code: "6640",
    description: "Non-Financial Intangible Assets (Except Copyrights) Leasing",
    division: "L",
    divisionName: "Rental, Hiring and Real Estate Services",
  },
  {
    code: "6711",
    description: "Residential Property Operators",
    division: "L",
    divisionName: "Rental, Hiring and Real Estate Services",
  },
  {
    code: "6712",
    description: "Non-Residential Property Operators",
    division: "L",
    divisionName: "Rental, Hiring and Real Estate Services",
  },
  {
    code: "6720",
    description: "Real Estate Services",
    division: "L",
    divisionName: "Rental, Hiring and Real Estate Services",
  },
  // Division M: Professional, Scientific and Technical Services
  {
    code: "6910",
    description: "Scientific Research Services",
    division: "M",
    divisionName: "Professional, Scientific and Technical Services",
  },
  {
    code: "6921",
    description: "Architectural Services",
    division: "M",
    divisionName: "Professional, Scientific and Technical Services",
  },
  {
    code: "6922",
    description: "Surveying and Mapping Services",
    division: "M",
    divisionName: "Professional, Scientific and Technical Services",
  },
  {
    code: "6923",
    description: "Engineering Design and Engineering Consulting Services",
    division: "M",
    divisionName: "Professional, Scientific and Technical Services",
  },
  {
    code: "6924",
    description: "Other Specialised Design Services",
    division: "M",
    divisionName: "Professional, Scientific and Technical Services",
  },
  {
    code: "6925",
    description: "Scientific Testing and Analysis Services",
    division: "M",
    divisionName: "Professional, Scientific and Technical Services",
  },
  {
    code: "6931",
    description: "Legal Services",
    division: "M",
    divisionName: "Professional, Scientific and Technical Services",
  },
  {
    code: "6932",
    description: "Accounting Services",
    division: "M",
    divisionName: "Professional, Scientific and Technical Services",
  },
  {
    code: "6940",
    description: "Advertising Services",
    division: "M",
    divisionName: "Professional, Scientific and Technical Services",
  },
  {
    code: "6950",
    description: "Market Research and Statistical Services",
    division: "M",
    divisionName: "Professional, Scientific and Technical Services",
  },
  {
    code: "6961",
    description: "Corporate Head Office Management Services",
    division: "M",
    divisionName: "Professional, Scientific and Technical Services",
  },
  {
    code: "6962",
    description: "Management Advice and Related Consulting Services",
    division: "M",
    divisionName: "Professional, Scientific and Technical Services",
  },
  {
    code: "6970",
    description: "Veterinary Services",
    division: "M",
    divisionName: "Professional, Scientific and Technical Services",
  },
  {
    code: "6991",
    description: "Professional Photographic Services",
    division: "M",
    divisionName: "Professional, Scientific and Technical Services",
  },
  {
    code: "6999",
    description: "Other Professional, Scientific and Technical Services n.e.c.",
    division: "M",
    divisionName: "Professional, Scientific and Technical Services",
  },
  {
    code: "7000",
    description: "Computer System Design and Related Services",
    division: "M",
    divisionName: "Professional, Scientific and Technical Services",
  },
  // Division N: Administrative and Support Services
  {
    code: "7211",
    description: "Employment Placement and Recruitment Services",
    division: "N",
    divisionName: "Administrative and Support Services",
  },
  {
    code: "7212",
    description: "Labour Supply Services",
    division: "N",
    divisionName: "Administrative and Support Services",
  },
  {
    code: "7220",
    description: "Travel Agency and Tour Arrangement Services",
    division: "N",
    divisionName: "Administrative and Support Services",
  },
  {
    code: "7291",
    description: "Office Administrative Services",
    division: "N",
    divisionName: "Administrative and Support Services",
  },
  {
    code: "7292",
    description: "Document Preparation Services",
    division: "N",
    divisionName: "Administrative and Support Services",
  },
  {
    code: "7293",
    description: "Credit Reporting and Debt Collection Services",
    division: "N",
    divisionName: "Administrative and Support Services",
  },
  {
    code: "7294",
    description: "Call Centre Operation",
    division: "N",
    divisionName: "Administrative and Support Services",
  },
  {
    code: "7299",
    description: "Other Administrative Services n.e.c.",
    division: "N",
    divisionName: "Administrative and Support Services",
  },
  {
    code: "7311",
    description: "Building and Other Industrial Cleaning Services",
    division: "N",
    divisionName: "Administrative and Support Services",
  },
  {
    code: "7312",
    description: "Building Pest Control Services",
    division: "N",
    divisionName: "Administrative and Support Services",
  },
  {
    code: "7313",
    description: "Gardening Services",
    division: "N",
    divisionName: "Administrative and Support Services",
  },
  {
    code: "7320",
    description: "Packaging Services",
    division: "N",
    divisionName: "Administrative and Support Services",
  },
  // Division O: Public Administration and Safety
  {
    code: "7510",
    description: "Central Government Administration",
    division: "O",
    divisionName: "Public Administration and Safety",
  },
  {
    code: "7520",
    description: "State Government Administration",
    division: "O",
    divisionName: "Public Administration and Safety",
  },
  {
    code: "7530",
    description: "Local Government Administration",
    division: "O",
    divisionName: "Public Administration and Safety",
  },
  {
    code: "7540",
    description: "Justice",
    division: "O",
    divisionName: "Public Administration and Safety",
  },
  {
    code: "7551",
    description: "Domestic Government Representation",
    division: "O",
    divisionName: "Public Administration and Safety",
  },
  {
    code: "7552",
    description: "Foreign Government Representation",
    division: "O",
    divisionName: "Public Administration and Safety",
  },
  {
    code: "7600",
    description: "Defence",
    division: "O",
    divisionName: "Public Administration and Safety",
  },
  {
    code: "7711",
    description: "Police Services",
    division: "O",
    divisionName: "Public Administration and Safety",
  },
  {
    code: "7712",
    description: "Investigation and Security Services",
    division: "O",
    divisionName: "Public Administration and Safety",
  },
  {
    code: "7713",
    description: "Fire Protection and Other Emergency Services",
    division: "O",
    divisionName: "Public Administration and Safety",
  },
  {
    code: "7714",
    description: "Correctional and Detention Services",
    division: "O",
    divisionName: "Public Administration and Safety",
  },
  {
    code: "7719",
    description: "Other Public Order and Safety Services",
    division: "O",
    divisionName: "Public Administration and Safety",
  },
  {
    code: "7720",
    description: "Regulatory Services",
    division: "O",
    divisionName: "Public Administration and Safety",
  },
  // Division P: Education and Training
  {
    code: "8010",
    description: "Preschool Education",
    division: "P",
    divisionName: "Education and Training",
  },
  {
    code: "8021",
    description: "Primary Education",
    division: "P",
    divisionName: "Education and Training",
  },
  {
    code: "8022",
    description: "Secondary Education",
    division: "P",
    divisionName: "Education and Training",
  },
  {
    code: "8023",
    description: "Combined Primary and Secondary Education",
    division: "P",
    divisionName: "Education and Training",
  },
  {
    code: "8024",
    description: "Special School Education",
    division: "P",
    divisionName: "Education and Training",
  },
  {
    code: "8101",
    description: "Technical and Vocational Education and Training",
    division: "P",
    divisionName: "Education and Training",
  },
  {
    code: "8102",
    description: "Higher Education",
    division: "P",
    divisionName: "Education and Training",
  },
  {
    code: "8211",
    description: "Sports and Physical Recreation Instruction",
    division: "P",
    divisionName: "Education and Training",
  },
  {
    code: "8212",
    description: "Arts Education",
    division: "P",
    divisionName: "Education and Training",
  },
  {
    code: "8219",
    description: "Adult, Community and Other Education n.e.c.",
    division: "P",
    divisionName: "Education and Training",
  },
  {
    code: "8220",
    description: "Educational Support Services",
    division: "P",
    divisionName: "Education and Training",
  },
  // Division Q: Health Care and Social Assistance
  {
    code: "8401",
    description: "Hospitals (Except Psychiatric Hospitals)",
    division: "Q",
    divisionName: "Health Care and Social Assistance",
  },
  {
    code: "8402",
    description: "Psychiatric Hospitals",
    division: "Q",
    divisionName: "Health Care and Social Assistance",
  },
  {
    code: "8511",
    description: "General Practice Medical Services",
    division: "Q",
    divisionName: "Health Care and Social Assistance",
  },
  {
    code: "8512",
    description: "Specialist Medical Services",
    division: "Q",
    divisionName: "Health Care and Social Assistance",
  },
  {
    code: "8520",
    description: "Pathology and Diagnostic Imaging Services",
    division: "Q",
    divisionName: "Health Care and Social Assistance",
  },
  {
    code: "8531",
    description: "Dental Services",
    division: "Q",
    divisionName: "Health Care and Social Assistance",
  },
  {
    code: "8532",
    description: "Optometry and Optical Dispensing",
    division: "Q",
    divisionName: "Health Care and Social Assistance",
  },
  {
    code: "8533",
    description: "Physiotherapy Services",
    division: "Q",
    divisionName: "Health Care and Social Assistance",
  },
  {
    code: "8534",
    description: "Chiropractic and Osteopathic Services",
    division: "Q",
    divisionName: "Health Care and Social Assistance",
  },
  {
    code: "8539",
    description: "Other Allied Health Services",
    division: "Q",
    divisionName: "Health Care and Social Assistance",
  },
  {
    code: "8591",
    description: "Ambulance Services",
    division: "Q",
    divisionName: "Health Care and Social Assistance",
  },
  {
    code: "8599",
    description: "Other Health Care Services n.e.c.",
    division: "Q",
    divisionName: "Health Care and Social Assistance",
  },
  {
    code: "8601",
    description: "Aged Care Residential Services",
    division: "Q",
    divisionName: "Health Care and Social Assistance",
  },
  {
    code: "8609",
    description: "Other Residential Care Services",
    division: "Q",
    divisionName: "Health Care and Social Assistance",
  },
  {
    code: "8710",
    description: "Child Care Services",
    division: "Q",
    divisionName: "Health Care and Social Assistance",
  },
  {
    code: "8790",
    description: "Other Social Assistance Services",
    division: "Q",
    divisionName: "Health Care and Social Assistance",
  },
  // Division R: Arts and Recreation Services
  {
    code: "8910",
    description: "Museum Operation",
    division: "R",
    divisionName: "Arts and Recreation Services",
  },
  {
    code: "8921",
    description: "Zoological and Botanical Gardens Operation",
    division: "R",
    divisionName: "Arts and Recreation Services",
  },
  {
    code: "8922",
    description: "Nature Reserves and Conservation Parks Operation",
    division: "R",
    divisionName: "Arts and Recreation Services",
  },
  {
    code: "9001",
    description: "Performing Arts Operation",
    division: "R",
    divisionName: "Arts and Recreation Services",
  },
  {
    code: "9002",
    description: "Creative Artists, Musicians, Writers and Performers",
    division: "R",
    divisionName: "Arts and Recreation Services",
  },
  {
    code: "9003",
    description: "Performing Arts Venue Operation",
    division: "R",
    divisionName: "Arts and Recreation Services",
  },
  {
    code: "9111",
    description: "Health and Fitness Centres and Gymnasia Operation",
    division: "R",
    divisionName: "Arts and Recreation Services",
  },
  {
    code: "9112",
    description: "Sport and Physical Recreation Clubs and Sports Professionals",
    division: "R",
    divisionName: "Arts and Recreation Services",
  },
  {
    code: "9113",
    description:
      "Sport and Physical Recreation Venues, Grounds and Facilities Operation",
    division: "R",
    divisionName: "Arts and Recreation Services",
  },
  {
    code: "9114",
    description: "Sport and Physical Recreation Administrative Service",
    division: "R",
    divisionName: "Arts and Recreation Services",
  },
  {
    code: "9121",
    description: "Horse and Dog Racing Administration and Track Operation",
    division: "R",
    divisionName: "Arts and Recreation Services",
  },
  {
    code: "9129",
    description: "Other Horse and Dog Racing Activities",
    division: "R",
    divisionName: "Arts and Recreation Services",
  },
  {
    code: "9131",
    description: "Amusement Parks and Centres Operation",
    division: "R",
    divisionName: "Arts and Recreation Services",
  },
  {
    code: "9139",
    description: "Amusement and Other Recreation Activities n.e.c.",
    division: "R",
    divisionName: "Arts and Recreation Services",
  },
  {
    code: "9201",
    description: "Casino Operation",
    division: "R",
    divisionName: "Arts and Recreation Services",
  },
  {
    code: "9202",
    description: "Lottery Operation",
    division: "R",
    divisionName: "Arts and Recreation Services",
  },
  {
    code: "9209",
    description: "Other Gambling Activities",
    division: "R",
    divisionName: "Arts and Recreation Services",
  },
  // Division S: Other Services
  {
    code: "9411",
    description: "Automotive Electrical Services",
    division: "S",
    divisionName: "Other Services",
  },
  {
    code: "9412",
    description: "Automotive Body, Paint and Interior Repair Services",
    division: "S",
    divisionName: "Other Services",
  },
  {
    code: "9419",
    description: "Other Automotive Repair and Maintenance",
    division: "S",
    divisionName: "Other Services",
  },
  {
    code: "9421",
    description: "Domestic Appliance Repair and Maintenance",
    division: "S",
    divisionName: "Other Services",
  },
  {
    code: "9422",
    description:
      "Electronic (except Domestic Appliance) and Precision Equipment Repair and Maintenance",
    division: "S",
    divisionName: "Other Services",
  },
  {
    code: "9429",
    description: "Other Machinery and Equipment Repair and Maintenance",
    division: "S",
    divisionName: "Other Services",
  },
  {
    code: "9491",
    description: "Clothing and Footwear Repair",
    division: "S",
    divisionName: "Other Services",
  },
  {
    code: "9499",
    description: "Other Repair and Maintenance n.e.c.",
    division: "S",
    divisionName: "Other Services",
  },
  {
    code: "9511",
    description: "Hairdressing and Beauty Services",
    division: "S",
    divisionName: "Other Services",
  },
  {
    code: "9512",
    description: "Diet and Weight Reduction Centre Operation",
    division: "S",
    divisionName: "Other Services",
  },
  {
    code: "9520",
    description: "Funeral, Crematorium and Cemetery Services",
    division: "S",
    divisionName: "Other Services",
  },
  {
    code: "9531",
    description: "Laundry and Dry-Cleaning Services",
    division: "S",
    divisionName: "Other Services",
  },
  {
    code: "9532",
    description: "Photographic Film Processing",
    division: "S",
    divisionName: "Other Services",
  },
  {
    code: "9533",
    description: "Parking Services",
    division: "S",
    divisionName: "Other Services",
  },
  {
    code: "9534",
    description: "Brothel Keeping and Prostitution Services",
    division: "S",
    divisionName: "Other Services",
  },
  {
    code: "9539",
    description: "Other Personal Services n.e.c.",
    division: "S",
    divisionName: "Other Services",
  },
  {
    code: "9540",
    description: "Religious Services",
    division: "S",
    divisionName: "Other Services",
  },
  {
    code: "9551",
    description: "Business and Professional Association Services",
    division: "S",
    divisionName: "Other Services",
  },
  {
    code: "9552",
    description: "Labour Association Services",
    division: "S",
    divisionName: "Other Services",
  },
  {
    code: "9559",
    description: "Other Interest Group Services n.e.c.",
    division: "S",
    divisionName: "Other Services",
  },
  {
    code: "9601",
    description: "Private Households Employing Staff",
    division: "S",
    divisionName: "Other Services",
  },
  {
    code: "9602",
    description:
      "Undifferentiated Goods-Producing Activities of Private Households for Own Use",
    division: "S",
    divisionName: "Other Services",
  },
  {
    code: "9603",
    description:
      "Undifferentiated Service-Producing Activities of Private Households for Own Use",
    division: "S",
    divisionName: "Other Services",
  },
];
